import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from '../../../hooks/useTranslatedField';
import { ListFacetGroup } from '../ListFacetGroup';
import BooleanFacet from '../BooleanFacet';

const MultiChoiceFacet = ({ name, slug, facets, selected, selectedManufacturers, onChange, reverse }) => {
  const t = useTranslation();

  const sortPriorityName = (a, b) => {
    return parseInt(a.orderingPriority) > parseInt(b.orderingPriority) || (a?.translatedName && b?.translatedName && t(a.translatedName).localeCompare(t(b.translatedName))) || 0;
  };

  const allOptions = facets.filter(({
    manufacturer,
    value: modelSlug
  }) => slug === 'model' ? (selectedManufacturers.indexOf(manufacturer?.slug) !== -1 || (modelSlug && selected.indexOf(modelSlug) !== -1)) : true).sort(sortPriorityName).filter(({ count }) => count > 0);
  const displayOptions = reverse ? allOptions.toReversed() : allOptions;
  if (!displayOptions.length) {
    return null;
  }
  const ts = {
    'IN_STOCK': 'In Stock'
  };
  return (
    <ListFacetGroup name={name}>
      {displayOptions.map(({ count, translatedName, value }) => {
        return (
          <BooleanFacet
            key={value}
            name={t(translatedName) || ts[value] || value}
            count={count}
            selected={selected.indexOf(value) !== -1}
            onChange={() => onChange(selected.indexOf(value) === -1 ? [...selected, value] : selected.filter(s => s !== value))}
          />
        );
      })}
    </ListFacetGroup>
  );
};
MultiChoiceFacet.defaultProps = {};
MultiChoiceFacet.propTypes = {
  slug: PropTypes.string.isRequired,
  selectedManufacturers: PropTypes.arrayOf(PropTypes.string).isRequired,
  name: PropTypes.node.isRequired,
  facets: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    count: PropTypes.number.isRequired,
    name: PropTypes.shape({
      ar: PropTypes.string.isRequired,
      en: PropTypes.string.isRequired
    })
  })),
  selected: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  onChange: PropTypes.func.isRequired
};
MultiChoiceFacet.defaultProps = {
  selected: [],
  facets: [],
  selectedManufacturers: [],
  onChange: () => {
  }
};


export default MultiChoiceFacet;
export { MultiChoiceFacet };